import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-nav-bar-enterprise',
  standalone: true,
  imports: [
    NgOptimizedImage,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './nav-bar-enterprise.component.html',
  styleUrl: './nav-bar-enterprise.component.css'
})
export class NavBarEnterpriseComponent {

}
